import type { FailingWorkflowRow } from "../../../shared/failingWorkflows";

export function formatFailureDuration(ms: number): string {
  const days = Math.floor(ms / 86_400_000);
  if (days >= 1) return `${days}d`;
  const hours = Math.floor(ms / 3_600_000);
  if (hours >= 1) return `${hours}h`;
  const minutes = Math.max(1, Math.floor(ms / 60_000));
  return `${minutes}m`;
}

export type FailingWorkflowSort = "duration" | "volume";

export function sortFailingWorkflows(
  rows: readonly FailingWorkflowRow[],
  sort: FailingWorkflowSort
): FailingWorkflowRow[] {
  const list = [...rows];
  list.sort((a, b) => {
    const primary =
      sort === "volume"
        ? b.failedRunCount - a.failedRunCount ||
          b.failureDurationMs - a.failureDurationMs
        : b.failureDurationMs - a.failureDurationMs ||
          b.failedRunCount - a.failedRunCount;
    if (primary !== 0) return primary;
    return a.name.localeCompare(b.name);
  });
  return list;
}
